import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RefreshService {
  triggerRefresh() {
    window.location.href = window.location.href;
    // Alternative methods:
    // window.location.reload(true);  // Force reload from server
    // OR
    // document.location.reload(true);  // Force reload from server
  }
} 